import { palette } from '@roleypoly/design-system/atoms/colors';
import styled, { css } from 'styled-components';
import { AvatarProps } from './Avatar';

type ContainerProps = Pick<AvatarProps, 'size'> & Pick<AvatarProps, 'deliberatelyEmpty'>;
export const Container = styled.div<ContainerProps>`
  border-radius: 100%;
  box-sizing: border-box;
  width: ${(props: ContainerProps) => props.size || 48}px;
  height: ${(props: ContainerProps) => props.size || 48}px;
  min-width: ${(props: ContainerProps) => props.size || 48}px;
  min-height: ${(props: ContainerProps) => props.size || 48}px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${palette.grey100};
  position: relative;
  background-color: ${palette.grey500};
  font-weight: 700;
  text-align: center;
  line-height: 1;
  overflow: hidden;
  font-size: ${(props: ContainerProps) => (props.size || 48) * 0.45}px;
  ${(props) =>
    props.deliberatelyEmpty &&
    css`
      border: 4px solid rgb(0 0 0 / 25%);
      background-color: ${palette.taupe400};
      color: ${palette.taupe600};
    `}
`;

type ImageProps = Pick<AvatarProps, 'src'>;
export const Image = styled.div<ImageProps>`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  border-radius: 100%;
`;
